import { FC } from "react";
import { useTranslation } from "react-i18next";
import languageServiceFactory from "../../../services/LanguageServiceImpl";
import LetterIconSVG from "../../resources/svg/LetterIconSVG";
import { contactsEmail, contactsPhone } from "../../../Config";
import PhoneIconSVG from "../../resources/svg/PhoneIconSVG";

const languageService = languageServiceFactory();

const ContactsPage: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="relative flex flex-col mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] dmin2:mb-[200px] td4:mb-[100px] tmax4:h-[calc(100vh-152px)]">
            <h1 className="H32B dmax2:H24B text-textWhite mb-[50px] dmax2:mb-6">{t("contacts.title")}</h1>
            <div className="bg-[rgba(255,255,255,0.05)] rounded-[9px] p-[38px] dmax2:px-4 dmax2:py-6">
                <p className="H32B dmax2:H24B text-textWhite mb-5 dmax2:mb-4">{t("contacts.firmName")}</p>
                {languageService.isUkrainian && (
                    <div className="mb-5 dmax2:mb-4">
                        <span className="H24B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">
                            {t("contacts.fullFirmNameLabel")}
                        </span>
                        <span className="H24 dmax2:H16 text-textFaded">{t("contacts.fullFirmName")}</span>
                    </div>
                )}
                <div className="mb-5 dmax2:mb-4">
                    <span className="H24B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">{t("contacts.countryLabel")}</span>
                    <span className="H24 dmax2:H16 text-textFaded">{t("contacts.country")}</span>
                </div>
                <div className="mb-6">
                    <span className="H24B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">
                        {t("contacts.correspondenceAddressLabel")}
                    </span>
                    <span className="H24 dmax2:H16 text-textFaded">{t("contacts.correspondenceAddress")}</span>
                </div>
                <div className="flex flex-col bg-[rgba(255,255,255,0.05)] rounded-[20px] px-8 dmax2:px-4 py-5">
                    <p className="H24B dmax2:H16B text-textWhite mb-6 dmax2:mb-5">{t("contacts.techSupport")}</p>
                    <div className="flex items-center mb-4 dmax2:mb-3">
                        <LetterIconSVG className="w-8 dmax2:w-5 h-8 dmax2:h-5 mr-3 dmax2:mr-2 text-textWhite" />
                        <span className="H24B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">
                            {t("contacts.emailLabel")}
                        </span>
                        <a
                            href={`mailto:${contactsEmail}`}
                            className="H24 dmax2:H16 text-textWhite"
                        >
                            {contactsEmail}
                        </a>
                    </div>
                    <div className="flex items-center">
                        <PhoneIconSVG className="w-8 dmax2:w-5 h-8 dmax2:h-5 mr-3 dmax2:mr-2 text-textWhite" />
                        <span className="H24B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">
                            {t("contacts.phoneLabel")}
                        </span>
                        <a
                            href={`tel:${contactsPhone}`}
                            className="H24 dmax2:H16 text-textWhite"
                        >
                            {contactsPhone}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactsPage;
